export default {
    islogin: false,
    loading: true,
    token: null,
    authcheck: false,
    role: null,
    user: [],
    expense_type: [],
    active_expense_type: [],
    expense: [],
    broke: [],
    category: [],
    company: [],
    customer: [],
    item: [],
    expire_item: [],
    service: [],
    removeditem: [],
    today_invoice: [],
    company_invoice_item: [],
    stok: [],
    expense_report: [],
    company_report: [],
    customer_report: [],
    returnbybarcode: [],
    return_item_company: [],
    summary_report_sell_array: [],
    summary_report_expense_amount: 0,
    stock_amount: 0,
    summary_report_damage_qty: 0,
    summary_report_damage_amount: 0,
    summary_report_return_item_company_qty: 0,
    summary_report_return_item_company_amount: 0,
    summary_report_total_service_price: 0,
    summary_report_total_service_price_cash: 0,
    summary_report_total_return_price: 0,
    total_sell_qty: 0,
    total_sell_price: 0,
    total_service_qty: 0,
    total_service_price: 0,
    total_return_qty: 0,
    total_return_price: 0,
    total_broke_qty: 0,
    total_broke_price: 0,
    item_sell_report_qty: 0,
    item_sell_report_price: 0,
    total_service_report_price: 0,
    total_service_report_qty: 0,
    loan_out: 0,
    loan_out_discount: 0,
    loan_in: 0,
    loan_in_discount: 0,
    ledger_customer_id: 0,
    ledger_customer_name: '',
    ledger_company_id: 0,
    ledger_company_name: '',
}